import { Link } from 'react-router-dom';
import Icon from '@/components/ui/Icon/Icon';
import { useCandidates, candidateStore, type Candidate } from '@/lib/candidate-store';
import styles from './CandidateRail.module.css';

type Props = {
  onCompare: () => void;
};

export default function CandidateRail({ onCompare }: Props) {
  const candidates = useCandidates();

  if (candidates.length === 0) {
    return null;
  }

  return (
    <aside className={styles.rail} aria-label="保存した候補地">
      <div className={styles.head}>
        <h3>保存した候補地</h3>
        <span className={styles.count}>{candidates.length} / 5</span>
      </div>

      <ul className={styles.list}>
        {candidates.map((c) => (
          <li key={c.id} className={styles.item}>
            <CandidateRow candidate={c} />
            <button
              type="button"
              className={styles.removeBtn}
              onClick={() => candidateStore.remove(c.id)}
              aria-label="削除"
            >
              ×
            </button>
          </li>
        ))}
      </ul>

      <div className={styles.actions}>
        <button
          type="button"
          className={styles.compareBtn}
          onClick={onCompare}
          disabled={candidates.length < 2}
        >
          <Icon name="sparkles" size={16} />
          候補地を比較する ({candidates.length})
        </button>
        <button
          type="button"
          className={styles.clearBtn}
          onClick={() => candidateStore.clear()}
        >
          すべて消す
        </button>
      </div>
    </aside>
  );
}

function CandidateRow({ candidate }: { candidate: Candidate }) {
  const params = new URLSearchParams();
  if (candidate.address) params.set('q', candidate.address);
  else {
    params.set('lat', candidate.point.lat.toFixed(6));
    params.set('lon', candidate.point.lon.toFixed(6));
  }
  return (
    <Link
      to={`/report?${params.toString()}`}
      className={styles.itemLink}
      aria-label={`${candidate.label} を再表示`}
    >
      <Icon name="map-pin" size={14} color="var(--color-sumi)" />
      <span className={styles.itemLabel}>{candidate.label}</span>
      <span className={styles.itemMeta}>
        ({candidate.point.lat.toFixed(3)}, {candidate.point.lon.toFixed(3)})
      </span>
    </Link>
  );
}
